import styled from 'styled-components'

const computePositionLeft = (isMobile: boolean, isSmallMobile: boolean) => {
  if (isSmallMobile) {
    return undefined
  }
  if (isMobile) {
    return '-79px'
  }

  return '-132px'
}

const computePositionTop = (isMobile: boolean, isSmallMobile: boolean) => {
  if (isSmallMobile) {
    return undefined
  }
  if (isMobile) {
    return '11px'
  }

  return '20px'
}

export const Wrapper = styled.div`
  position: relative;
`

export const BadgeWrapper = styled.div<{
  isMobile: boolean
  isSmallMobile: boolean
}>`
  position: absolute;
  left: ${({ isMobile, isSmallMobile }) =>
    computePositionLeft(isMobile, isSmallMobile)};
  top: ${({ isMobile, isSmallMobile }) =>
    computePositionTop(isMobile, isSmallMobile)};
`
